// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__IfoZo","marginBottomSm":"Grid_marginBottomSm__0-u2A","marginBottomMd":"Grid_marginBottomMd__oMbwe","marginBottomLg":"Grid_marginBottomLg__biV-W"};